<app-property-search 
    [paginate]="true"
    [lazyLoad]="true"
    [showform]="false"
    [autoSearch]="false"
    [autosearchCriteriaPath]="'cfvars:PropertySearch:PropertySearchCriteria'"
  ></app-property-search>
